/* istanbul ignore file */
import IconAttachmentPaperclip from './IconAttachmentPaperclip/IconAttachmentPaperclip';
import IconAvatar from './IconAvatar/IconAvatar';
import IconCalculator from './IconCalculator/IconCalculator';
import IconCaretDown from './IconCaretDown/IconCaretDown';
import IconCaretUp from './IconCaretUp/IconCaretUp';
import IconChevronLeft from './IconChevronLeft/IconChevronLeft';
import IconChevronRight from './IconChevronRight/IconChevronRight';
import IconCheckmarkCircle from './IconCheckmarkCircle/IconCheckmarkCircle';
import IconCheckmarkFill from './IconCheckmarkFill/IconCheckmarkFill';
import IconClose from './IconClose/IconClose';
import IconCompose from './IconCompose/IconCompose';
import IconContactCard from './IconContactCard/IconContactCard';
import IconDataDownload from './IconDataDownload/IconDataDownload';
import IconDataUpload from './IconDataUpload/IconDataUpload';
import IconDataVisBarChart from './IconDataVisBarChart/IconDataVisBarChart';
import IconDataVisColumnChart from './IconDataVisColumnChart/IconDataVisColumnChart';
import IconDataVisComboChart from './IconDataVisComboChart/IconDataVisComboChart';
import IconDataVisHierarchy from './IconDataVisHierarchy/IconDataVisHierarchy';
import IconDataVisLineGraph from './IconDataVisLineGraph/IconDataVisLineGraph';
import IconDataVisPieChart from './IconDataVisPieChart/IconDataVisPieChart';
import IconDataVisTrendAsc from './IconDataVisTrendAsc/IconDataVisTrendAsc';
import IconDataVisTrendDesc from './IconDataVisTrendDesc/IconDataVisTrendDesc';
import IconDateCalendar from './IconDateCalendar/IconDateCalendar';
import IconDateClock from './IconDateClock/IconDateClock';
import IconDirectoryFolder from './IconDirectoryFolder/IconDirectoryFolder';
import IconEditPencil from './IconEditPencil/IconEditPencil';
import IconEditDisabledPencil from './IconEditDisabledPencil/IconEditDisabledPencil';
import IconFilter from './IconFilter/IconFilter';
import IconGridThree from './IconGridThree/IconGridThree';
import IconGridTwo from './IconGridTwo/IconGridTwo';
import IconHelpQuestionMark from './IconHelpQuestionMark/IconHelpQuestionMark';
import IconHome from './IconHome/IconHome';
import IconList from './IconList/IconList';
import IconLockLocked from './IconLockLocked/IconLockLocked';
import IconLockUnlocked from './IconLockUnlocked/IconLockUnlocked';
import IconMembersPeople from './IconMembersPeople/IconMembersPeople';
import IconFeedbackBubble from './IconFeedbackBubble/IconFeedbackBubble';
import IconMessageEnvelope from './IconMessageEnvelope/IconMessageEnvelope';
import IconMessageForward from './IconMessageForward/IconMessageForward';
import IconMessageReply from './IconMessageReply/IconMessageReply';
import IconMessageReplyAll from './IconMessageReplyAll/IconMessageReplyAll';
import IconMessageSend from './IconMessageSend/IconMessageSend';
import IconMoreEllipsis from './IconMoreEllipsis/IconMoreEllipsis';
import IconNewWindow from './IconNewWindow/IconNewWindow';
import IconNoticeErrorFill from './IconNoticeErrorFill/IconNoticeErrorFill';
import IconNoticeError from './IconNoticeError/IconNoticeError';
import IconNoticeImportant from './IconNoticeImportant/IconNoticeImportant';
import IconNoticeInfo from './IconNoticeInfo/IconNoticeInfo';
import IconNoticeWarning from './IconNoticeWarning/IconNoticeWarning';
import IconObjectAdd from './IconObjectAdd/IconObjectAdd';
import IconObjectSubtract from './IconObjectSubtract/IconObjectSubtract';
import IconPrint from './IconPrint/IconPrint';
import IconProtectionShield from './IconProtectionShield/IconProtectionShield';
import IconRefreshSync from './IconRefreshSync/IconRefreshSync';
import IconSearch from './IconSearch/IconSearch';
import IconSettingsCog from './IconSettingsCog/IconSettingsCog';
import IconSortable from './IconSortable/IconSortable';
import IconSortAsc from './IconSortAsc/IconSortAsc';
import IconSortDesc from './IconSortDesc/IconSortDesc';
import IconTable from './IconTable/IconTable';
import IconTag from './IconTag/IconTag';
import IconTransferArrows from './IconTransferArrows/IconTransferArrows';
import IconTrash from './IconTrash/IconTrash';
import IconZoomIn from './IconZoomIn/IconZoomIn';
import IconZoomOut from './IconZoomOut/IconZoomOut';
import IconObjectAddSm from './IconObjectAdd/IconObjectAddSm';
import IconComposeSm from './IconCompose/IconComposeSm';
import IconTrashSm from './IconTrash/IconTrashSm';
import IconEditPencilSm from './IconEditPencil/IconEditPencilSm';
import IconObjectSubtractSm from './IconObjectSubtract/IconObjectSubtractSm';
import IconSettingsCogSm from './IconSettingsCog/IconSettingsCogSm';

export default {
  'object-add-sm': IconObjectAddSm(),
  'compose-sm': IconComposeSm(),
  'trash-sm': IconTrashSm(),
  'edit-pencil-sm': IconEditPencilSm(),
  'object-subtract-sm': IconObjectSubtractSm(),
  'settings-cog-sm': IconSettingsCogSm(),
  'attachment-paperclip': IconAttachmentPaperclip(),
  'avatar': IconAvatar(),
  'calculator': IconCalculator(),
  'caret-down': IconCaretDown(),
  'caret-up': IconCaretUp(),
  'chevron-left': IconChevronLeft(),
  'chevron-right': IconChevronRight(),
  'checkmark-circle': IconCheckmarkCircle(),
  'checkmark-fill': IconCheckmarkFill(),
  'close': IconClose(),
  'compose': IconCompose(),
  'contact-card': IconContactCard(),
  'data-download': IconDataDownload(),
  'data-upload': IconDataUpload(),
  'data-vis-bar-chart': IconDataVisBarChart(),
  'data-vis-column-chart': IconDataVisColumnChart(),
  'data-vis-combo-chart': IconDataVisComboChart(),
  'data-vis-hierarchy': IconDataVisHierarchy(),
  'data-vis-line-graph': IconDataVisLineGraph(),
  'data-vis-pie-chart': IconDataVisPieChart(),
  'data-vis-trend-asc': IconDataVisTrendAsc(),
  'data-vis-trend-desc': IconDataVisTrendDesc(),
  'date-calendar': IconDateCalendar(),
  'date-clock': IconDateClock(),
  'trash': IconTrash(),
  'directory-folder': IconDirectoryFolder(),
  'edit-pencil': IconEditPencil(),
  'edit-disabled-pencil': IconEditDisabledPencil(),
  'feedback-bubble': IconFeedbackBubble(),
  'filter': IconFilter(),
  'grid-three': IconGridThree(),
  'grid-two': IconGridTwo(),
  'help-question-mark': IconHelpQuestionMark(),
  'home': IconHome(),
  'list': IconList(),
  'lock-locked': IconLockLocked(),
  'lock-unlocked': IconLockUnlocked(),
  'members-people': IconMembersPeople(),
  'message-envelope': IconMessageEnvelope(),
  'message-forward': IconMessageForward(),
  'message-reply': IconMessageReply(),
  'message-reply-all': IconMessageReplyAll(),
  'message-send': IconMessageSend(),
  'more-ellipsis': IconMoreEllipsis(),
  'new-window': IconNewWindow(),
  'notice-error-fill': IconNoticeErrorFill(),
  'notice-error': IconNoticeError(),
  'notice-important': IconNoticeImportant(),
  'notice-info': IconNoticeInfo(),
  'notice-warning': IconNoticeWarning(),
  'object-add': IconObjectAdd(),
  'object-subtract': IconObjectSubtract(),
  'print': IconPrint(),
  'protection-shield': IconProtectionShield(),
  'refresh-sync': IconRefreshSync(),
  'search': IconSearch(),
  'settings-cog': IconSettingsCog(),
  'sortable': IconSortable(),
  'sort-asc': IconSortAsc(),
  'sort-desc': IconSortDesc(),
  'table': IconTable(),
  'tag': IconTag(),
  'transfer-arrows': IconTransferArrows(),
  'zoom-in': IconZoomIn(),
  'zoom-out': IconZoomOut(),
};
